(() => {
  if (window.productGalleryFixesLoaded) return;
  window.productGalleryFixesLoaded = true;

  const sliderSelector = '[data-product-single-media-slider]';
  const gestures = new Map();
  const dragThreshold = 8;

  const getSlider = (event) => event.target.closest?.(sliderSelector);

  document.addEventListener('pointerdown', (event) => {
    const slider = getSlider(event);
    if (!slider) return;

    gestures.set(event.pointerId, {
      slider,
      startX: event.clientX,
      startY: event.clientY,
      moved: false,
    });
  }, true);

  document.addEventListener('pointermove', (event) => {
    const gesture = gestures.get(event.pointerId);
    if (!gesture || gesture.moved) return;

    gesture.moved =
      Math.abs(event.clientX - gesture.startX) > dragThreshold ||
      Math.abs(event.clientY - gesture.startY) > dragThreshold;
  }, true);

  document.addEventListener('pointerup', (event) => {
    const gesture = gestures.get(event.pointerId);
    if (!gesture) return;

    const { slider } = gesture;
    gestures.delete(event.pointerId);
    if (gesture.moved) {
      setTimeout(() => slider.classList.remove('is-moving'), 0);
    } else {
      slider.classList.remove('is-moving');
    }
  }, true);

  document.addEventListener('pointercancel', (event) => {
    const gesture = gestures.get(event.pointerId);
    if (!gesture) return;

    gestures.delete(event.pointerId);
    gesture.slider.classList.remove('is-moving');
  }, true);
})();
